var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3088",
    "data-name": "Rectangle 3088",
    width: 20,
    height: 20,
    fill: "#ccc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "searchIcon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M4.006,21.7,8.54,17.161a8.429,8.429,0,1,1,1.7,1.7L5.707,23.4a1.2,1.2,0,0,1-1.7-1.7ZM21.3,12.121a6.014,6.014,0,1,0-6.014,6.014A6.014,6.014,0,0,0,21.3,12.121Z",
    transform: "translate(-3.701 -3.701)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.73dadb31861190175037d22f0b91ba24.svg";
export { ForwardRef as ReactComponent };